import React, { useState } from 'react';
import { X, Clock } from 'lucide-react';
import './SeguimientoModal.css';

const SeguimientoModal = ({ post, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    status: post.Estado_Actual || 'Registrado',
    comment: '',
    date: new Date().toISOString().slice(0, 16)
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const seguimiento = Array.isArray(post.seguimiento) ? post.seguimiento : [];
  const sortedHistory = [...seguimiento].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <div className="modal-overlay" data-testid="seguimiento-modal" onClick={onClose}>
      <div className="modal-content modal-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">Seguimiento de Publicación</h3>
          <button className="modal-close" onClick={onClose} data-testid="close-seguimiento-modal-btn">
            <X size={20} />
          </button>
        </div>

        <div className="modal-body">
          {/* Estado Actual */}
          <div className="current-status">
            <div className="status-label">Estado actual:</div>
            <span className={`status-badge-lg status-${post.Estado_Actual?.toLowerCase().replace(/\s+/g, '-')}`}>
              {post.Estado_Actual || 'Registrado'}
            </span>
          </div>

          {/* Formulario Nueva Entrada */}
          <form onSubmit={handleSubmit} className="seguimiento-form">
            <h4 className="form-subtitle">Registrar Nuevo Seguimiento</h4>
            
            <div className="form-grid">
              <div className="form-group">
                <label>Estado *</label>
                <select
                  data-testid="seguimiento-status"
                  value={formData.status}
                  onChange={(e) => handleChange('status', e.target.value)}
                  required
                >
                  <option value="Registrado">Registrado</option>
                  <option value="Enviado/Compartido">Enviado/Compartido</option>
                  <option value="En proceso averiguación">En proceso averiguación</option>
                  <option value="Archivado">Archivado</option>
                </select>
              </div>

              <div className="form-group">
                <label>Fecha y Hora *</label>
                <input
                  type="datetime-local"
                  data-testid="seguimiento-date"
                  value={formData.date}
                  onChange={(e) => handleChange('date', e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Comentario</label>
              <textarea
                data-testid="seguimiento-comment"
                placeholder="Detalle del seguimiento..."
                value={formData.comment}
                onChange={(e) => handleChange('comment', e.target.value)}
                rows="3"
              />
            </div>

            <div className="form-actions">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Cancelar
              </button>
              <button type="submit" className="btn btn-primary" data-testid="save-seguimiento-btn">
                Registrar Seguimiento
              </button>
            </div>
          </form>

          {/* Historial */}
          <div className="history-section">
            <h4 className="history-title">
              <Clock size={18} />
              Historial de Seguimiento
            </h4>
            
            {sortedHistory.length === 0 ? (
              <div className="history-empty">
                No hay registros de seguimiento aún
              </div>
            ) : (
              <div className="history-list" data-testid="seguimiento-history">
                {sortedHistory.map((entry, index) => (
                  <div key={entry.id || index} className="history-item">
                    <div className="history-header">
                      <span className={`status-badge status-${entry.status?.toLowerCase().replace(/\s+/g, '-')}`}>
                        {entry.status}
                      </span>
                      <span className="history-date">
                        {new Date(entry.date).toLocaleString('es-ES', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </span>
                    </div>
                    {entry.comment && (
                      <div className="history-comment">{entry.comment}</div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeguimientoModal;
